import { useToast } from '@uhg-abyss/web/hooks/useToast';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';

import { toastSuccessStyle } from './Toast.style';

export const successToast = (message: string) => {
  const { toast } = useToast();

  toast.show({
    message: (
      <Text
        color="white"
        data-auto-testid="success-message"
        data-testid="success-message"
      >
        {message}
      </Text>
    ),
    type: 'success',
    icon: <IconSymbol color="white !important" icon="check_circle" />,
    css: toastSuccessStyle,
  });
};
